var _g;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIcMessageLight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeDasharray: "0,0",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.333 12.667c-2.666 0-4-.667-4-4V5.333c0-2.666 1.334-4 4-4h5.334c2.666 0 4 1.334 4 4v3.334c0 2.666-1.334 4-4 4h-.334c-.206 0-.406.1-.533.266l-1 1.334c-.44.586-1.16.586-1.6 0l-1-1.334a.754.754 0 00-.533-.266h-.334z",
    strokeWidth: 1.2
  }), /*#__PURE__*/React.createElement("path", {
    strokeWidth: 1.333,
    d: "M10.664 7.333h.006M7.996 7.333h.006M5.33 7.333h.006"
  }))));
}

export default SvgIcMessageLight;